// @general/audit - frontend surface.

export const routes = [
  {
    path: '/audit',
    name: 'audit',
    component: () => import('./views/AuditView.vue'),
    meta: { permission: 'audit:read', title: 'audit.title' },
  },
]

export const navigation = [
  { to: '/audit', labelKey: 'audit.title', permission: 'audit:read', icon: 'list', group: 'platform' },
]

export default { routes, navigation }
